export const SET_HAS_VEHICLE = 'SET_HAS_VEHICLE';

export const SetHasVehicle = (value) => {
    return {
        type: SET_HAS_VEHICLE,
        payload: {
            value: value
        }
    }
}